import React from "react";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function CustomerFullNameRequiredWarning({ name }) {
  if (!name) return null;
  if ([" ", ","].some(k => name.includes(k))) {
    return null;
  }

  return (
    <Warning>
      To complete this transaction, the customer contact selected must have a
      first and last name. Please change or edit contact name to continue.
    </Warning>
  );
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/Warnings/CustomerFullNameRequiredWarning.jsx